import React, { useState } from 'react';

import { useParams } from 'react-router-dom';

import CRMApi from '../../../../Api/CRM/CRMApi';
import GetLootboxResponse from '../../../../Api/CRM/Responses/Lootbox/LootboxResponse';
import { formatDateStringWithTimezone } from '../../../../utils/formatters';
import BooleanIcon from '../../../elements/booleanIcon';
import useOnce from '../../../hooks/useOnce';

import Card from 'crm/elements/common/Card';
import Row, { TableDetailsBody } from 'crm/elements/common/TableDetailsRow';

export default function LootboxDetailsPage() {
    const { id } = useParams<{ id: string }>();
    const [lootbox, setLootbox] = useState<GetLootboxResponse>({} as GetLootboxResponse);
    useOnce(() => CRMApi.lootboxes.getById(parseInt(id)).then(setLootbox));

    return (
        <Card title="Lootbox details">
            <TableDetailsBody>
                <Row label="ID">{lootbox.id}</Row>
                <Row label="Slug">{lootbox.slug}</Row>
                <Row label="Enabled">
                    <BooleanIcon value={lootbox.is_enabled} />
                </Row>
                <Row label="Description">{lootbox.description}</Row>
                <Row label="Price">{lootbox.price}</Row>
                <Row label="Price Currency Code">{lootbox.price_currency_code}</Row>

                <Row label="Created at">{formatDateStringWithTimezone(lootbox.created_at)}</Row>
            </TableDetailsBody>
        </Card>
    );
}
